import { render, staticRenderFns } from "./SwitchSettings.vue?vue&type=template&id=78e77737&"
import script from "./SwitchSettings.vue?vue&type=script&lang=js&"
export * from "./SwitchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports